import * as types from '../mutation-types';

// initial state
const state = () => ({
  accepted: false,
});

// getters
const getters = {
  cookiesAccepted: (state) => state.accepted,
};

// actions
const actions = {
  acceptCookies({ commit }) {
    commit(types.COOKIES_ACCEPTED);
  },
};

// mutations
const mutations = {
  [types.COOKIES_ACCEPTED](state) {
    state.accepted = true;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
